// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Account_avatar__1lTuL"};